import { Stack, Heading, Text } from "@chakra-ui/react";
import { FC } from "react";
import { Indicator } from "../../../types/Indicator/Indicator";
import getReferenceTextHelper from "../../../helpers/Indicator/getReferenceTextHelper";

interface IndicatorDetailsProps {
  indicator: Indicator;
}

const IndicatorDetails: FC<IndicatorDetailsProps> = ({ indicator }) => {
  return (
    <Stack gap="4">
      <Heading as="h4" fontSize="xl">
        Dados do indicador
      </Heading>
      <Stack direction="row" spacing={10}>
        <Stack>
          <Text fontWeight="bold" whiteSpace="nowrap">
            Sub-sistema:
          </Text>
          <Text fontWeight="bold" whiteSpace="nowrap">
            Frequência de recolha:
          </Text>
          <Text fontWeight="bold" whiteSpace="nowrap">
            Referências do indicador:
          </Text>
          <Text fontWeight="bold" whiteSpace="nowrap">
            Nível:
          </Text>
        </Stack>
        <Stack>
          <Text whiteSpace="nowrap">{indicator?.subSystem?.name ?? "-"}</Text>
          <Text whiteSpace="nowrap">{indicator?.frequency?.name ?? "-"}</Text>
          <Text whiteSpace="nowrap">{getReferenceTextHelper(indicator)}</Text>
          <Text whiteSpace="nowrap">{indicator?.level?.name || "-"}</Text>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default IndicatorDetails;
